// 表格数据
import { getAccountLog, getProfile } from "../service/user";
import { getLhShengXiao, getLotteryResults, getRules } from "../service/lottery";

export const state = {
  d23: {
    profile: [],
    userinfo: {}
  },
  d13: [],
  d21: {records: [], total: 1},
  d22: [],
  inputValues: {48284: 1},
  shengxiaoData: {}
};

export const actions = {
  // 获取个人用户数据
  async load_d23_data({commit}) {
    const info = await getProfile();
    if (info.result === "ok") {
      commit("SET_D23_DATA", info.data);
    }
  },
  async load_d21_data({commit}, params) {
    const info = await getLotteryResults(params);
    if (info.result === "ok") {
      commit("SET_D21_DATA", info.data);
    }
  },
  async load_d22_data({commit}, {offset, limit}) {
    const info = await getAccountLog({offset, limit});
    if (info.result === "ok") {
      commit("SET_D22_DATA", info.data);
    }
  },
  async load_d13_data({commit}, {lottery_type}) {
    const info = await getRules({lottery_type});
    if (info.result === "ok") {
      commit("SET_D13_DATA", info.data);
    }
  },
  // 保存input的value
  saveInputValie({commit}, {value}) {
    commit("SET_INPUT_VALUE", value);
  },
  // 六合生肖号码数据
  async load_lh_shengxiao({commit}) {
    const info = await getLhShengXiao();
    commit("SET_LH_SHENGXIAO", info);
  }
};

export const mutations = {
  ["SET_D23_DATA"](state, d23) {
    state.d23 = d23;
  },
  ["SET_D21_DATA"](state, d21) {
    state.d21 = d21;
  },
  ["SET_D22_DATA"](state, d22) {
    state.d22 = d22;
  },
  ["SET_D13_DATA"](state, d13) {
    state.d13 = d13;
  },
  ["SET_INPUT_VALUE"](state, value) {
    state.inputValues = {...state.inputValues, ...value};
  },
  ["SET_LH_SHENGXIAO"](state, value) {
    state.shengxiaoData = value;
  }
};



// WEBPACK FOOTER //
// ./src/store/table.js